import { type Country } from "~/api/tills/types";

export const getSupportInfoFromCountryCode = (countryCode: Country) => {
  switch (countryCode) {
    case "GB":
      return {
        email: "support@kanpla.io",
        phone: "+448081607050",
        supportHours: "8:15 - 15:00 CEST"
      };
    case "NL":
      return {
        email: "support@kanpla.io",
        phone: "+31 970 102 74765",
        supportHours: "8:15 - 15:00 CEST"
      };
    case "US":
      return {
        email: "support@kanpla.io",
        phone: "+1 877 749 7022",
        supportHours: "2AM - 3PM"
      };
    default:
      return {
        email: "support@kanpla.dk",
        phone: "+4552515070",
        supportHours: "8:15 - 15:00 CEST"
      };
  }
};
